import React from 'react';
import IndexTableFiltersPanelLabel from './IndexTableFiltersPanelLabel';
import IndexTableFiltersPanelInput from './IndexTableFiltersPanelInput';
import TypingTester from '../../../TypingTester';
import IndexTableFiltersPanelSelect from './IndexTableFiltersPanelSelect';
import IndexTableFiltersPanelMultiSelect from './IndexTableFiltersPanelMultiSelect';
import Filter from '../../../model/index-table/Filter';
import IndexTableFiltersPanelDate from './IndexTableFiltersPanelDate';
import IndexTableFiltersPanelScalarDate from './IndexTableFiltersPanelScalarDate';
import IndexTableFiltersPanelScalar from './IndexTableFiltersPanelScalar';
import * as Helper from '../IndexHelpers';
import IndexTableFiltersPanelChips from '../IndexTableFiltersPanelChips';

export default class IndexTableFiltersPanel extends React.Component {
    IndexTableFiltersPanelMultiSelectClass = IndexTableFiltersPanelMultiSelect;

    state = {
        values: {},
        queries: []
    }

    constructor(props) {
        super(props);
        this.typingTester = new TypingTester(200);
        this.addOrReplaceQuery = this.addOrReplaceQuery.bind(this);
        this.addCollectionStateValue = this.addCollectionStateValue.bind(this);
        this.createOnInputChangeStateValue = this.createOnInputChangeStateValue.bind(this);
        this.onInputChange = this.onInputChange.bind(this);

        this.setStateWithFilter(props.filter);
    }

    callOnFiltersChange() {
        this.props.onFiltersChange(this.state.queries);
    }

    setStateWithFilter(filter) {
        let values = {};
        let queries = [];

        for (let i = 0; i < filter.length; i++) {
            let component = this.getFilterComponentByType(Helper.getPropType(filter[i]));
            var inputState = component.getInputStateValue(filter[i]);
            if (inputState !== null && inputState !== undefined) {

                values[filter[i].meta.slug] = inputState;
                if (typeof (component.fillQueries) === "function") {
                    queries = component.fillQueries(filter[i], queries);
                } else {
                    queries.push(this.createQueryAndLabel(filter[i], inputState))

                }
            }
        }

        this.state.values = values;
        this.state.queries = queries;

    }

    createOnInputChangeStateValue(prop, value) {
        return {
            value: value.value,
            text: value.text,
            index: value.index,
            type: prop.meta.type,
            dirty: true
        };
    }

    createQueryAndLabel(filterProp, inputState) {
        return {
            label: filterProp.meta.name + ': ' + inputState.text,
            slug: filterProp.meta.slug,
            value: inputState.value,
            index: inputState.index,
            type: Helper.getPropType(filterProp),
            color: Helper.getFilterColor()
        }
    }

    onBlur = (prop) => {
        let val = this.state.values[prop.meta.slug]
        if (val.dirty === false)
            return;

        if (val.type === 'Scalar' && val.value['value' + (val.index + 1)] === '') {
            this.removeQueryBySlug(prop.meta.slug, val.index)
            return;
        }

        if (val.value !== undefined && val.value !== null && val.value !== '') {
            this.addOrReplaceQuery({
                label: prop.meta.name + ': ' + val.text,
                slug: prop.meta.slug,
                value: val.value,
                index: val.index,
                type: Helper.getPropType(prop),
                color: Helper.getFilterColor(),
                dirty: val.dirty
            })
        } else {
            this.removeQueryBySlug(prop.meta.slug)
        }
    }

    onInputChange(prop, value, forceToChange) {
        if (this.props.isLoading === true) {
            return;
        }

        let stateValue = this.createOnInputChangeStateValue(prop, value);

        this.setState({
            values: {
                ...this.state.values,
                [prop.meta.slug]: stateValue
            }
        }, () => {
            if (forceToChange) {
                this.onBlur(prop);
            }
        })
    }

    addOrReplaceQuery(query) {
        let currentQueries = this.state.queries
        let sameQueryIndex = currentQueries.findIndex(x => x.slug === query.slug && x.index === query.index)
        if (sameQueryIndex > -1) {
            query.color = currentQueries[sameQueryIndex].color
            currentQueries.splice(sameQueryIndex, 1)
        }

        let nextQueries = [
            ...currentQueries,
            query
        ]

        let nextValues = {
            ...this.state.values,
            [query.slug]: {
                ...this.state.values[query.slug],
                dirty: false
            }
        };

        this.setState({queries: nextQueries, values: nextValues}, () => {
            this.addCollectionStateValue(query);
            this.props.onFiltersChange(nextQueries)
        })
    }

    removeQueryBySlug(slug, index) {
        let queries = this.state.queries
        let queryIndex = queries.findIndex(x => x.slug === slug && x.index === index)
        if (queryIndex > -1) {
            queries.splice(queryIndex, 1)
        }

        let nextValues = {
            ...this.state.values,
            [slug]: {
                ...this.state.values[slug],
                dirty: false
            }
        };

        this.setState({queries: queries, values: nextValues})
        this.props.onFiltersChange(queries)
    }

    addCollectionStateValue(query) {
        if (query.type !== 'Collection') {
            return;
        }
        let queries = this.state.queries.filter(q => q.slug == query.slug);
        let values = queries.map(q => q.value);
        let stateValue = this.state.values[query.slug];
        stateValue.value = values;

        let nextValues = {
            ...this.state.values,
            [query.slug]: {
                value: values
            }
        };

        this.setState({
            values: nextValues
        })
    }

    onFilterRemoveRequested = query => {
        this.removeQueryBySlug(query.slug, query.index);
        let values = this.state.values;
        if (query.type === 'ScalarDate' || query.type === 'Scalar') {
            let queryValue = this.state.values[query.slug];
            let valueId = "value" + (query.index + 1);
            queryValue.value[valueId] = "";

            values[query.slug] = queryValue;

            if (queryValue.value.value1 === "" && queryValue.value.value2 === "") {
                delete values[query.slug];
            }
        } else if (query.type === 'Collection') {
            let stateValue = this.state.values[query.slug];
            let queries = this.state.queries.filter(q => q.slug == query.slug);
            let values = queries.map(q => q.value);
            stateValue.value = values;

            if (stateValue.value.length === 0) {
                delete values[query.slug];
            }
        } else {
            delete values[query.slug];
        }

        this.setState({
            values: values
        });
    }

    handleClearButtonClick = () => {
        let queries = [];
        this.setState({queries: queries, values: {}});
        this.props.onFiltersChange(queries);
    }

    render() {
        return (
            <div className="index-table-filters-panel">
                {this.renderFilterChips()}
                <div className="filters-panel-row filters-panel-inputs">
                    {this.props.filter.map(this.renderProp)}
                </div>
            </div>
        )
    }

    renderFilterChips() {
        var chips = this.state.queries.map((query, index) => (
            <IndexTableFiltersPanelLabel key={index} color={query.color} label={query.label}
                                         onRemove={() => this.onFilterRemoveRequested(query)}/>
        ));

        return (
            <IndexTableFiltersPanelChips
                chips={chips}
                handleClearButtonClick={this.handleClearButtonClick}
            />
        )
    }

    renderProp = (prop, index) => {
        const PropComponent = this.getFilterComponentByType(Helper.getPropType(prop))

        if (!PropComponent)
            return <React.Fragment key={index}/>

        return (
            <PropComponent key={index}
                           label={prop.meta.name}
                           prop={prop}
                           value={this.state.values[prop.meta.slug] ? this.state.values[prop.meta.slug].value : ''}
                           onBlur={() => this.onBlur(prop)}
                           onChange={(value, forceChange) => this.onInputChange(prop, value, forceChange)}
            />
        )
    }

    getFilterComponentByType(type) {

        let IndexTableFiltersPanelMultiSelectComponent = this.IndexTableFiltersPanelMultiSelectClass;

        switch (type) {
            case Filter.Type.Collection:
                return IndexTableFiltersPanelMultiSelectComponent;
            case Filter.Type.ScalarDate:
                return IndexTableFiltersPanelScalarDate;
            case Filter.Type.Date:
                return IndexTableFiltersPanelDate;
            case Filter.Type.Scalar:
                return IndexTableFiltersPanelScalar;
            case Filter.Type.Select:
                return IndexTableFiltersPanelSelect;
            default:
                return IndexTableFiltersPanelInput;
        }
    }
}